/**
 * Created by liux on 2018/2/26.
 * 封装端上的jsbridge://协议，包装全局注册的 callback, bridge命名空间_xy_jsBridge
 * @params url|String, [data|Object], [cb|Function]，data中的http链接需要调用的时候encodeURIComponent
 * @true 调起端上协议，注册回调函数
 */
import {parse} from '../helper/utils'
import getBrowserInfo from '../helper/getBrowserInfo'
var isBjAPP = getBrowserInfo().isBjAPP;
window.xyJSBridgeInfo = parse(window.xyJSBridge) || {}
function openJsBridge(url, data, cb, once) {
  if(!isBjAPP) return false;// 不在北京App里面直接退出，兼容在某些webview里面调jsbridge:// scheme 报错
  if (!url || typeof url !== 'string') {
    throw ('调用 openJsBridge 模块传入参数错误');
    return false;
  }
  if (typeof cb === 'boolean') {
    once = cb;
  }
  switch (typeof data) {
    case 'boolean':
      once = data;
      break;
    case 'function':
      cb = data;
  }
  var params = {}, src, iframe, body;
  if (data && typeof data === 'object') {
    for(let key in data){
      if(typeof data[key] === 'function'){
        params[key] = transformCb(data[key], key)
      }else {
        params[key] = data[key]
      }
    }
  }
  if(typeof cb === 'function'){
    params.callback = transformCb(cb, 'callback')
  }

  function transformCb (func, name = '') {
      let key = url.replace('jsbridge://www.xiaoying.com/', '').replace(/\//g, '_');
      var suffix = new Date().getTime() + '' + Math.floor(Math.random() * 1e6);
      key = key + name + suffix;
      function callback(data) {
        if (typeof data === 'string') {
          data = parse(decodeURIComponent(data));
        }
        func(data);
        if (once) {
          delete _xy_jsBridge[key];
        }
      }
      if (window._xy_jsBridge && typeof window._xy_jsBridge === 'object') {
        window._xy_jsBridge[key] = callback;
      } else {
        window._xy_jsBridge = {[key]: callback};
      }
      return `_xy_jsBridge.${key}`;
  }

  params = encodeURIComponent(JSON.stringify(params));
  src = `${url}?params=${params}`;
  iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'position:absolute;z-index:-1;left:0;bottom:0;width:0;height:0;opacity:0;border:none;');
  iframe.frameborder = 0;
  iframe.src = src;
  body = document.getElementsByTagName('body')[0];
  body.appendChild(iframe);
  setTimeout(() => {
    body.removeChild(iframe);
  }, 1000);

  return true;
}
export default openJsBridge;
